import {QueryKey} from '@tanstack/query-core';

import {UseQueryOptions, UseQueryResult} from '@tanstack/react-query';
import {useBaseQuery} from './useBaseQuery';

export function useHighFrequencyRefreshQuery<
    TQueryFnData = unknown,
    TError = unknown,
    TData = TQueryFnData,
    TQueryKey extends QueryKey = QueryKey,
>(options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>): UseQueryResult<TData, TError> {
    const staleTime = 5 * (60 * 1000); // 5 minutes

    return useBaseQuery<TQueryFnData, TError, TData, TQueryKey>({
        ...options,
        staleTime,
    });
}
